import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import { Provider, useStore } from 'jotai';
import SubscriptionStore from '@components/subscription/store/SubscriptionStore';
import { haveBottomNavbar } from '@atom/navbarAtom';
import SubscriptionSnackbar from '@components/subscription/micro/SubscriptionSnackbar';
import SubscriptionFetchManager from '@pages/subscription/SubscriptionFetchManager';

const SubscriptionBase = () => {
  const store = useStore();

  useEffect(() => {
    store.set(haveBottomNavbar, false);
  });

  return (
    <>
      <Helmet>
        <title>Geniebook - Subscription</title>
        <meta name="description" content="Subscription" />
      </Helmet>
      <Provider store={SubscriptionStore}>
        <SubscriptionFetchManager>
          <Outlet />
          <SubscriptionSnackbar />
        </SubscriptionFetchManager>
      </Provider>
    </>
  );
};

export default SubscriptionBase;
